import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Help Circle Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-help-circle-outline',
    templateUrl: './icon-help-circle-outline.component.html',
    styleUrls: ['./icon-help-circle-outline.component.scss'],
    standalone: false
})
export class IconHelpCircleOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
